module.exports = __webpack_public_path__ + "static/media/homebg2.97b5ebf6.jpg";